const ERR_TEXT_WEB_SERVICE_BASE_URL = 'environment variable REACT_APP_WEB_APP_BASE_HOST is empty';
const ERR_TEXT_API_SERVICE_BASE_URL = 'environment variable ERR_TEXT_API_SERVICE_BASE_URL is empty';
const ERR_TEXT_COMPANION_SERVICE_BASE_URL =
  'environment variable COMPANION_SERVICE_BASE_URL is empty';

// return the proper base url for methods
export function getBaseUrl(component) {
  const WEB_SERVICE_BASE_URL = process.env.REACT_APP_WEB_APP_BASE_HOST;
  const API_SERVICE_BASE_URL = process.env.REACT_APP_API_SERVICE_BASE_HOST;
  const COMPANION_SERVICE_BASE_URL = process.env.REACT_APP_COMPANION_SERVICE_BASE_HOST;

  if (isEmpty(WEB_SERVICE_BASE_URL)) {
    console.error(ERR_TEXT_WEB_SERVICE_BASE_URL);
    throw new Error(ERR_TEXT_WEB_SERVICE_BASE_URL);
  }

  if (isEmpty(API_SERVICE_BASE_URL)) {
    console.error(ERR_TEXT_API_SERVICE_BASE_URL);
    throw new Error(ERR_TEXT_API_SERVICE_BASE_URL);
  }

  if (isEmpty(COMPANION_SERVICE_BASE_URL)) {
    console.error(ERR_TEXT_COMPANION_SERVICE_BASE_URL);
    throw new Error(ERR_TEXT_COMPANION_SERVICE_BASE_URL);
  }

  switch (component) {
    case 'api':
      return API_SERVICE_BASE_URL;
    case 'webapp':
      return WEB_SERVICE_BASE_URL;
    case 'companion':
      return COMPANION_SERVICE_BASE_URL;
    default:
      return API_SERVICE_BASE_URL;
  }
}

function isEmpty(str) {
  return !str || 0 === str.length;
}

export const handleUnauthorizedResponseAndReload = (response, id) => {
  if (response?.status === 401) {
    const reloadCount = localStorage.getItem('`${id}-reloadCount`');
    if (reloadCount < 3) {
      localStorage.setItem(`${id}-reloadCount`, reloadCount + 1);
      window.location.reload();
    }
  } else {
    localStorage.removeItem('`${id}-reloadCount`');
  }
};
